import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SnackbarSmallTitle({ className, children }) {
    return <div className={cn('text-sm font-normal', className)}>{children}</div>;
}

SnackbarSmallTitle.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
